export enum ChangelogType {
  SpecialRule,
  EnvSync,
  Ranger
}

export enum ChangelogAction {
  Create,
  Update,
  Delete,
  Archive
}

export type ChangelogEntry = {
  id: string;
  username: string;
  created: Date;
  payload: ChangelogPayload;
  type: ChangelogType;
  entity_id?: string;
  entity_name?: string;
};

export type ChangelogPayload = {
  action: ChangelogAction;
  changes: (string | ChangelogChange)[];
};

export type ChangelogChange = {
  property: string;
  before?: any;
  after?: any;
};
